module.exports = __webpack_public_path__ + "static/media/advancing_dash.b1efedec.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/advancing_dash.png
// module id = 252
// module chunks = 0